import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { EntityTypeEnum } from '../../../../enums/entity-type.enum';

@Component({
    selector: 'app-single-address-container',
    templateUrl: './single-address-container.component.html',
    styleUrls: ['./single-address-container.component.scss'],
})
export class SingleAddressContainerComponent {
    @Input() public control: FormControl;
    @Input() public entityType: EntityTypeEnum;
    @Input() public readonly: boolean;

    @Output() public elementSizeModification = new EventEmitter<void>();
}
